import { GiroWebappError } from 'model/error';
import { PersonSimple } from 'model/person';
import { action } from 'typesafe-actions';
import { AcceptLgpdTermsActionTypes } from './types';

export const acceptLgpdTermsRequest = () => action(AcceptLgpdTermsActionTypes.ACCEPT_LGPD_TERMS_REQUEST);
export const acceptLgpdTermsSuccess = (person: PersonSimple) => action(AcceptLgpdTermsActionTypes.ACCEPT_LGPD_TERMS_SUCCESS, person);
export const acceptLgpdTermsError = (error: GiroWebappError) => action(AcceptLgpdTermsActionTypes.ACCEPT_LGPD_TERMS_ERROR, error);
export const acceptLgpdTermsResetState = () => action(AcceptLgpdTermsActionTypes.ACCEPT_LGPD_TERMS_RESET_STATE);
